
export default {
    trackingData: [],
    loading: true
}
